<script lang="ts">
  import {
    Col,
    Row,

  } from "sveltestrap"
</script>

<Row class="footer align-items-center" cols={{ xs: 1, sm: 2 }}>
  <Col>
    <Row class="footer-sns-row">
      <Col class="col-auto">
        <a class="footer-sns" href="https://twitter.com/PilgrimProtocol" target="_blank">
          <img class="icon-small" src="/icons/twitter.svg" alt="placeholder"/>
          Twitter
        </a>
      </Col>
      <Col class="col-auto">
        <a class="footer-sns" href="https://discord.com/invite/pilgrimprotocol" target="_blank">
          <img class="icon-small" src="/icons/discord.svg" alt="placeholder"/>
          Discord
        </a>
      </Col>
      <Col class="col-auto">
        <a class="footer-sns" href="https://t.me/pilgrimprotocol" target="_blank">
          <img class="icon-small" src="/icons/telegram.svg" alt="placeholder"/>
          Telegram
        </a>
      </Col>
    </Row>
  </Col>
  <Col class="footer-signature">
    © Signed off by Test in Prod.
  </Col>
</Row>
